export const SERVICE_HOST = process.env.REACT_APP_SERVICE_HOST;
